import {
  Separator,
  Shimmer,
  ShimmerElementsGroup,
  ShimmerElementType,
  Stack,
} from '@fluentui/react';
import React, { JSX } from 'react';
import { useStyles } from './index.styles';

export const ShimmerSection = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.fullWidthContainer}>
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 30, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '10%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '10%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '10%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '10%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
          { type: ShimmerElementType.line, height: 20, width: '10%' },
          { type: ShimmerElementType.gap, height: 20, width: '15%' },
          { type: ShimmerElementType.line, height: 20, width: '15%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 10, width: '100%' },
        ]}
      />
    </div>
  );
};

export const ShimmerSection1 = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.fullWidthContainer}>
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 10, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '40%' },
          { type: ShimmerElementType.gap, height: 20, width: '20%' },
          { type: ShimmerElementType.line, height: 20, width: '40%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />

      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '40%' },
          { type: ShimmerElementType.gap, height: 20, width: '20%' },
          { type: ShimmerElementType.line, height: 20, width: '40%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />

      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '40%' },
          { type: ShimmerElementType.gap, height: 20, width: '20%' },
          { type: ShimmerElementType.line, height: 20, width: '40%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />

      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '40%' },
          { type: ShimmerElementType.gap, height: 20, width: '20%' },
          { type: ShimmerElementType.line, height: 20, width: '40%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
    </div>
  );
};

export const ShimmerSection2 = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.fullWidthContainer}>
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '30%' },
          { type: ShimmerElementType.gap, height: 20, width: '70%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '50%' },
          { type: ShimmerElementType.gap, height: 20, width: '50%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '30%' },
          { type: ShimmerElementType.gap, height: 20, width: '20%' },
          { type: ShimmerElementType.line, height: 20, width: '30%' },
          { type: ShimmerElementType.gap, height: 20, width: '20%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '40%' },
          { type: ShimmerElementType.gap, height: 20, width: '60%' },
        ]}
      />
    </div>
  );
};

export const ShimmerSection3 = (): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={styles.fullWidthContainer}>
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '30%' },
          { type: ShimmerElementType.gap, height: 20, width: '70%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '30%' },
          { type: ShimmerElementType.gap, height: 20, width: '60%' },
          { type: ShimmerElementType.line, height: 20, width: '5%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '30%' },
          { type: ShimmerElementType.gap, height: 20, width: '60%' },
          { type: ShimmerElementType.line, height: 20, width: '5%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '30%' },
          { type: ShimmerElementType.gap, height: 20, width: '60%' },
          { type: ShimmerElementType.line, height: 20, width: '5%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.gap, height: 25, width: '100%' },
        ]}
      />
      <ShimmerElementsGroup
        width="100%"
        shimmerElements={[
          { type: ShimmerElementType.line, height: 20, width: '30%' },
          { type: ShimmerElementType.gap, height: 20, width: '60%' },
          { type: ShimmerElementType.line, height: 20, width: '5%' },
          { type: ShimmerElementType.gap, height: 20, width: '5%' },
        ]}
      />
    </div>
  );
};

export const ShimmerView: React.FC = () => {
  const styles = useStyles();
  return (
    <React.Fragment>
      <Stack className={styles.containerpadding}>
        <Shimmer customElementsGroup={ShimmerSection()} />
      </Stack>
      <Separator />
      <Stack className={styles.containerpadding}>
        <Shimmer customElementsGroup={ShimmerSection1()} />
      </Stack>
      <Separator />

      <Stack className={styles.containerpadding}>
        <Shimmer customElementsGroup={ShimmerSection2()} />
      </Stack>
      <Separator />
      <Stack className={styles.containerpadding}>
        <Shimmer customElementsGroup={ShimmerSection3()} />
      </Stack>
      <Separator />
    </React.Fragment>
  );
};
